export default __webpack_public_path__ + "static/media/playicon.bf8d35bb.svg";